var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMjmEmployers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.091,
    height: 39.091,
    viewBox: "0 0 39.091 39.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7s7bb5cnaa",
    x1: 1.047,
    y1: 0.5,
    x2: -1.311,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x26k0ofgmb",
    x1: 0.5,
    y1: 0.336,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#fe4600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e51400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t2qnv508ec",
    x1: 0.5,
    y1: 0.314,
    x2: 0.884,
    y2: 1.223,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acrayfgecd",
    x1: 0.548,
    y1: -0.622,
    x2: 0.538,
    y2: 0.209,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 19.545,
    cy: 19.545,
    style: {
      fill: "#fff"
    },
    r: 19.545
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 155",
    transform: "translate(8.656 5.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 180",
    width: 6.449,
    height: 1.988,
    rx: 0.994,
    transform: "translate(3.318 9.104)",
    style: {
      fill: "url(#7s7bb5cnaa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 184",
    width: 6.449,
    height: 1.988,
    rx: 0.994,
    transform: "translate(3.318 4.792)",
    style: {
      fill: "url(#7s7bb5cnaa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 181",
    width: 13.055,
    height: 1.988,
    rx: 0.994,
    transform: "translate(3.318 13.416)",
    style: {
      fill: "url(#7s7bb5cnaa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 183",
    width: 12.117,
    height: 1.988,
    rx: 0.994,
    transform: "translate(3.318 17.728)",
    style: {
      fill: "url(#7s7bb5cnaa)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 72",
    d: "M18.236 24.994H.938A.938.938 0 0 1 0 24.056V.938A.938.938 0 0 1 .938 0h11.253a.938.938 0 0 1 .937.938v4.673l5.119.063a.938.938 0 0 1 .926.938v17.443a.938.938 0 0 1-.937.939zm-16.36-1.875H17.3V7.538l-5.12-.063a.938.938 0 0 1-.926-.938V1.875H1.876z",
    style: {
      fill: "url(#x26k0ofgmb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    d: "M.771 1.3a.934.934 0 0 1-.639-.251L-5.7-4.376A.938.938 0 0 1-5.749-5.7a.938.938 0 0 1 1.325-.048L1.411-.319A.938.938 0 0 1 .771 1.3z",
    transform: "translate(17.476 6.156)",
    style: {
      fill: "#ff4800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 73",
    d: "M12.422 2.165V6.29h5.308z",
    transform: "translate(-.009 -.002)",
    style: {
      fill: "#ff4800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M6.009 42.591a12.96 12.96 0 0 0 6.009-1.468c-.525-5.97-2.6-10.433-6.009-10.492C2.538 30.571.525 35.153 0 41.123a12.961 12.961 0 0 0 6.009 1.468",
    transform: "translate(12.762 -15.278)",
    style: {
      fill: "url(#t2qnv508ec)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58",
    d: "M6.009 42.591a12.96 12.96 0 0 0 6.009-1.468c-.525-5.97-2.6-10.433-6.009-10.492C2.538 30.571.525 35.153 0 41.123a12.961 12.961 0 0 0 6.009 1.468",
    transform: "translate(12.762 -15.278)",
    style: {
      fill: "url(#acrayfgecd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M18.35 3.609A3.609 3.609 0 1 1 14.741 0a3.609 3.609 0 0 1 3.609 3.609",
    transform: "translate(4.031 8.748)",
    style: {
      fill: "#0379a0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjmEmployers);
export default __webpack_public_path__ + "static/media/MJM-Employers.0f74056d9c563e575c741d43994943aa.svg";
export { ForwardRef as ReactComponent };